import React from "react";
import TextField from '@material-ui/core/TextField';

export default function ({ titleError, title, messageError, message, tagsError, tags, onChangeField }) {
    return (
        <React.Fragment>
            <br/>
            <label htmlFor="Mensagem"style={{ display: 'block', color: '#BBBBBB' }}>
                Mensagem
            </label>
            <TextField
                fullWidth
                error={messageError !== '' && messageError !== null}
                helperText={messageError}
                value={message}
                onChange={event => onChangeField('message', event.target.value)}
            />
        </React.Fragment>
    );
}


// WEBPACK FOOTER //
// ./src/components/highlights/fields/HighlightsBodyField.js